




















































































































































import { Vue, Component } from "@/shared/vuepack";
import * as elements from "@/shared/elementsUrls";
import { openUrl } from "@/shared/urlHelper";

@Component({
  components: {
  }
})
export default class ElementsForms extends Vue {
  ElementsUrls = elements;

  clickLink (event) {
    openUrl(event.currentTarget.href);
  }
}
